import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';

import { ACTIONS_TYPES } from 'redux/helper';
import { _t } from 'utils';
import { useSelector } from 'react-redux';
import { ROUTE } from 'constant';
import useFilter from './hooks/group-filter';
import CreateForm from './create';

export default ({ history }) => {
  const { listViewType = '' } = useSelector((e) => e);
  const [groups, , FilterComponent] = useFilter();

  useEffect(() => {
    actions.group.getAll();
  }, []);

  useEffect(() => {
    actions.common.setLayoutTitle({
      layout: {
        title: _t('User Management'),
        menu: ROUTE.DASHBOARD.USER_MANAGEMENT.key,
      },
    });
  }, []);

  return (
    <div className="screen-user-managements screen-common" style={{ margin: '15px 10px' }}>
      <Shared.widgets.Cards
        title={_t('Groups')}
        type="common"
        onFilter={() => ''}
        filterRender={FilterComponent}
        addAction={ACTIONS_TYPES.GROUP.CREATE}
        addRender={<CreateForm />}
      >
        {listViewType === 'table' ? (
          <Shared.widgets.TableView
            name="servers"
            rows={
              groups.map((group) => {
                const { properties, id } = group;
                const {
                  name,
                } = properties;

                return ([
                  <Shared.widgets.Icon name="users" />,
                  {
                    value: name,
                    link: id,
                  },
                ]);
              })
            }
            onCellClick={(id) => history.push(`/user-management/group/${id}`)}
            columns={[
              { name: '' },
              { name: 'Name' },
            ]}
          />
        ) : (groups.map((group) => {
          const { properties, id } = group;
          const {
            name,
          } = properties;

          return (
            <Shared.widgets.CardBasic
              icon="users"
              title={name}
              onClick={() => history.push(`/user-management/group/${id}`)}
              key={id}
            />
          );
        }))}
      </Shared.widgets.Cards>
    </div>
  );
};
